const currentDate = new Date()
let after30DaysDate = new Date()
after30DaysDate.setDate(after30DaysDate.getDate() + 30)
const contracts = {
  permissionSource: 'api::contract.contract',
  creationTitle: 'Create Contract',
  creationEndPoint: '/contracts',
  detailTitle: 'Contract: :code',
  detailEndPoint:
    '/contracts/:id?populate[0]=business_entity&populate[1]=document_type&populate[2]=client.whatsapp&populate[3]=staff&populate[4]=contact_person.whatsapp&populate[5]=associated_invoice.order_items.product&populate[6]=e_sign',
  detail: [
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Code',
              value: 'code',
              tag: 'input',
              type: 'text',
              placeholder: 'Contract Code',
              required: true,
            },
            {
              label: 'Document Type',
              value: 'document_type',
              tag: 'single-select',
              dataSourceUrl: '/document-types',
              dataLabel: 'title',
            },
            {
              label: 'Client',
              value: 'client',
              tag: 'single-select',
              dataSourceUrl: '/clients',
              dataLabel: 'name',
              required: true,
            },
            {
              label: "Contact Person (Client's side)",
              value: 'contact_person',
              tag: 'single-select',
              dataSourceUrl: '/contact-people',
              dataLabel: 'name',
            },
          ],
        },
        {
          isLayout: true,
          layoutPattern: '1',
          children: [
            {
              label: 'Business Entity',
              value: 'business_entity',
              tag: 'single-select',
              dataSourceUrl: '/business-entities',
              dataLabel: 'title',
              required: true,
            },
            {
              label: 'Staff (Our side)',
              value: 'staff',
              tag: 'single-select',
              dataSourceUrl: '/staffs',
              dataLabel: 'name',
              required: true,
            },
            {
              label: 'E-Sign',
              value: 'e_sign',
              tag: 'single-select',
              dataSourceUrl: '/e-signs',
              dataLabel: 'description',
            },
          ],
        },
      ],
    },
    {
      label: 'Remark',
      value: 'remark',
      tag: 'richTextarea',
    },
    {
      label: 'Sales Invoice',
      value: 'associated_invoice',
      tag: 'single-select',
      dataSourceUrl: '/sales-invoices',
      dataLabel: 'code',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
  creationData: {
    business_entity: ':active_business_entity',
    create_date: currentDate,
    expiry_date: after30DaysDate,
  },
}
export default contracts
